module.exports = __webpack_public_path__ + "img/Enmascarar-grupo-3-new.0dd80773.png";